var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 100,
    width: 100,
    viewBox: "-10 -10 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 64H75l2.1-28H90c3.3 0 6-2.7 6-6s-2.7-6-6-6H78l1-13.5c0.3-3.3-2.2-6.2-5.5-6.4 -3.3-0.2-6.2 2.2-6.4 5.5L65.9 24H38l1-13.5c0.3-3.3-2.2-6.2-5.5-6.4 -3.3-0.2-6.2 2.2-6.4 5.5L25.9 24H10c-3.3 0-6 2.7-6 6s2.7 6 6 6h15l-2.1 28H10c-3.3 0-6 2.7-6 6s2.7 6 6 6h12l-1 13.6c-0.2 3.3 2.2 6.2 5.5 6.4C26.7 96 26.9 96 27 96c3.1 0 5.7-2.4 6-5.5L34.1 76h28l-1 13.6c-0.2 3.3 2.2 6.2 5.5 6.4C66.7 96 66.9 96 67 96c3.1 0 5.7-2.4 6-5.5L74.1 76H90c3.3 0 6-2.7 6-6S93.3 64 90 64zM35 64l2.1-28h28l-2.1 28H35z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.19d84527e4bb3e92a05cd91961057c14.svg";
export { ForwardRef as ReactComponent };